import { Component, Input } from '@angular/core';

@Component({
    selector: 'menu-button',
    styles: [`
        
        button {
            width: 100%;
        }
        
        .nav-icon {
            padding-right: 8px;
            padding-bottom: 4px;
        }
        
        .menu-button {
            text-align: left;
            font-size: 18px;
            padding-top: 5px;
            padding-bottom: 5px;
        }

        .selected-menu-item {
            background: #D7D7D7;
        }
    `],
    template: `
        <button mat-button
                fxFlex
                class="menu-button"
                [routerLink]="link"
                routerLinkActive="selected-menu-item">
            <i class="nav-icon material-icons">{{icon}}</i>{{label}}
        </button>
    `
})
export class MenuButtonComponent {
    @Input() icon: string;
    @Input() label: string;
    @Input() link: string;
}
